// src/reducers/haryanaReducers.js
import {
    GET_HARYANA_RECORDS_REQUEST,
    GET_HARYANA_RECORDS_SUCCESS,
    GET_HARYANA_RECORDS_FAIL,
    GET_HARYANA_RECORDS_RESET,
    CREATE_HARYANA_RECORD_REQUEST,
    CREATE_HARYANA_RECORD_SUCCESS,
    CREATE_HARYANA_RECORD_FAIL,
    CREATE_HARYANA_RECORD_RESET,
    UPDATE_HARYANA_RECORD_REQUEST,
    UPDATE_HARYANA_RECORD_SUCCESS,
    UPDATE_HARYANA_RECORD_FAIL,
    UPDATE_HARYANA_RECORD_RESET,
    DELETE_HARYANA_RECORD_REQUEST,
    DELETE_HARYANA_RECORD_SUCCESS,
    DELETE_HARYANA_RECORD_FAIL,
    DELETE_HARYANA_RECORD_RESET,
    BULK_DELETE_HARYANA_RECORDS_REQUEST,
    BULK_DELETE_HARYANA_RECORDS_SUCCESS,
    BULK_DELETE_HARYANA_RECORDS_FAIL,
    BULK_DELETE_HARYANA_RECORDS_RESET,
    IMPORT_HARYANA_RECORDS_REQUEST,
    IMPORT_HARYANA_RECORDS_SUCCESS,
    IMPORT_HARYANA_RECORDS_FAIL,
    IMPORT_HARYANA_RECORDS_RESET,
    EXPORT_HARYANA_RECORDS_REQUEST,
    EXPORT_HARYANA_RECORDS_SUCCESS,
    EXPORT_HARYANA_RECORDS_FAIL,
    EXPORT_HARYANA_RECORDS_RESET
} from '../constants/harayanaConstants';

// Get Haryana Records Reducer
export const getHaryanaRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_HARYANA_RECORDS_REQUEST:
            return { loadingGetHaryanaRecords: true };
        case GET_HARYANA_RECORDS_SUCCESS:
            return {
                loadingGetHaryanaRecords: false,
                getHaryanaRecordsData: action.payload,
            };
        case GET_HARYANA_RECORDS_FAIL:
            return {
                loadingGetHaryanaRecords: false,
                errorGetHaryanaRecords: action.payload,
            };
        case GET_HARYANA_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};



export const createHaryanaRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_HARYANA_RECORD_REQUEST:
            return { loading: true };
        case CREATE_HARYANA_RECORD_SUCCESS:
            return { loading: false, success: true, record: action.payload };
        case CREATE_HARYANA_RECORD_FAIL:
            return { loading: false, error: action.payload };
        case CREATE_HARYANA_RECORD_RESET:
            return {};
        default:
            return state;
    }
};


// Import Haryana Records Reducer
export const importHaryanaRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case IMPORT_HARYANA_RECORDS_REQUEST:
            return { loadingImportHaryanaRecords: true };
        case IMPORT_HARYANA_RECORDS_SUCCESS:
            return {
                loadingImportHaryanaRecords: false,
                importHaryanaRecordsData: action.payload,
            };
        case IMPORT_HARYANA_RECORDS_FAIL:
            return {
                loadingImportHaryanaRecords: false,
                errorImportHaryanaRecords: action.payload,
            };
        case IMPORT_HARYANA_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};

// Export Haryana Records Reducer
export const exportHaryanaRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case EXPORT_HARYANA_RECORDS_REQUEST:
            return { loadingExportHaryanaRecords: true };
        case EXPORT_HARYANA_RECORDS_SUCCESS:
            return {
                loadingExportHaryanaRecords: false,
                exportHaryanaRecordsData: action.payload,
            };
        case EXPORT_HARYANA_RECORDS_FAIL:
            return {
                loadingExportHaryanaRecords: false,
                errorExportHaryanaRecords: action.payload,
            };
        case EXPORT_HARYANA_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};


// Update Haryana Record Reducer
export const updateHaryanaRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_HARYANA_RECORD_REQUEST:
            return { loadingUpdateHaryanaRecord: true };
        case UPDATE_HARYANA_RECORD_SUCCESS:
            return {
                loadingUpdateHaryanaRecord: false,
                updateHaryanaRecordData: action.payload,
            };
        case UPDATE_HARYANA_RECORD_FAIL:
            return {
                loadingUpdateHaryanaRecord: false,
                errorUpdateHaryanaRecord: action.payload,
            };
        case UPDATE_HARYANA_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Delete Haryana Record Reducer
export const deleteHaryanaRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_HARYANA_RECORD_REQUEST:
            return { loading: true };
        case DELETE_HARYANA_RECORD_SUCCESS:
            return { loading: false, success: true };
        case DELETE_HARYANA_RECORD_FAIL:
            return { loading: false, error: action.payload };
        case DELETE_HARYANA_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Bulk Delete Haryana Records Reducer
export const bulkDeleteHaryanaRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case BULK_DELETE_HARYANA_RECORDS_REQUEST:
            return { loadingBulkDeleteHaryanaRecords: true };
        case BULK_DELETE_HARYANA_RECORDS_SUCCESS:
            return {
                loadingBulkDeleteHaryanaRecords: false,
                bulkDeleteHaryanaRecordsData: action.payload,
            };
        case BULK_DELETE_HARYANA_RECORDS_FAIL:
            return {
                loadingBulkDeleteHaryanaRecords: false,
                errorBulkDeleteHaryanaRecords: action.payload,
            };
        case BULK_DELETE_HARYANA_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};
